import React, { FC, memo } from "react";
import { Tooltip } from "@mui/material";
import { FaFolder } from "react-icons/fa";
import { palette } from "@/themes/tokens";

interface DocumentsButtonProps {
    count?: number | string;
    onClick: (event: React.MouseEvent<HTMLElement>) => void;
}

// Same as the mobile app's documents avatar: a round ink button with a folder and a red count badge.
const DocumentsButton: FC<DocumentsButtonProps> = ({ count, onClick }) => (
    <Tooltip arrow title="View Documents" placement="bottom" PopperProps={{ style: { zIndex: 0 } }}>
        <button
            type="button"
            aria-label="Documents"
            aria-haspopup="true"
            onClick={onClick}
            style={{
                position: "relative",
                width: 36,
                height: 36,
                borderRadius: 18,
                border: 0,
                padding: 0,
                flexShrink: 0,
                background: palette.ink,
                color: "#fff",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
            }}
        >
            <FaFolder size={17} />
            {Number(count) > 0 && (
                <span
                    style={{
                        position: "absolute",
                        top: -4,
                        left: 20,
                        minWidth: 18,
                        height: 18,
                        padding: "0 5px",
                        borderRadius: 9,
                        background: palette.danger,
                        color: "#fff",
                        fontSize: 11,
                        fontWeight: 700,
                        lineHeight: "18px",
                        textAlign: "center",
                        border: "2px solid #fff",
                        boxSizing: "content-box",
                    }}
                >
                    {count}
                </span>
            )}
        </button>
    </Tooltip>
);

export default memo(DocumentsButton);
